import { render, staticRenderFns } from "./WizardSummary.vue?vue&type=template&id=1da32492&scoped=true"
import script from "./WizardSummary.vue?vue&type=script&lang=ts"
export * from "./WizardSummary.vue?vue&type=script&lang=ts"
import style0 from "./WizardSummary.vue?vue&type=style&index=0&id=1da32492&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da32492",
  null
  
)

export default component.exports